'use client'

import { Fragment } from 'react'
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import { X } from 'lucide-react'
import { panelFocusRing } from './SidePanel'

export default function CenterModal({ open, onClose, title, subtitle, footer, children, className = '' }: { open: boolean, onClose: () => void, title: React.ReactNode, subtitle?: React.ReactNode, footer?: React.ReactNode, children: React.ReactNode, className?: string }) {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <TransitionChild as={Fragment} enter="transition-opacity ease-out duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-in duration-150" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-foreground/30" />
        </TransitionChild>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="min-h-full flex items-center justify-center p-4 sm:p-8">
            <TransitionChild as={Fragment} enter="transition ease-out duration-200 motion-reduce:transition-none" enterFrom="opacity-0 translate-y-2" enterTo="opacity-100 translate-y-0" leave="transition ease-in duration-150 motion-reduce:transition-none" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 translate-y-2">
              <DialogPanel className={`w-full max-w-2xl flex flex-col max-h-[calc(100dvh-2rem)] sm:max-h-[calc(100dvh-4rem)] bg-background text-foreground ${className}`}>
                <div className="flex items-start justify-between gap-6 px-6 sm:px-10 pt-7 shrink-0">
                  <DialogTitle className="text-xl sm:text-2xl tracking-tight">{title}</DialogTitle>
                  <button type="button" onClick={onClose} aria-label="Хаах" className={`-mr-2 -mt-1 size-9 shrink-0 grid place-items-center transition-opacity duration-150 hover:opacity-60 ${panelFocusRing}`}>
                    <X className="size-5" strokeWidth={1.25} />
                  </button>
                </div>
                {subtitle && <div className="px-6 sm:px-10 shrink-0">{subtitle}</div>}
                <div className="flex-1 overflow-y-auto overscroll-contain px-6 sm:px-10 pt-6 pb-8">
                  {children}
                </div>
                {footer && <div className="shrink-0 border-t border-border px-6 sm:px-10 py-5">{footer}</div>}
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
